import { createFileRoute } from "@tanstack/react-router";
import TimestampConverterPage from "@/pages/TimestampConverterPage";

export const Route = createFileRoute("/tools/timestamp-converter")({
  component: TimestampConverterPage,
});
